import actionsTypes from './cta.types';

export default {
  [actionsTypes.FETCH_CTAS_SUCCESS](state, payload) {
    state.type = actionsTypes.FETCH_CTAS_SUCCESS;
    state.data = { ...state.data, ...payload.data };
  },
  [actionsTypes.FETCH_CTAS_FAILED](state, payload) {
    state.type = actionsTypes.FETCH_CTAS_FAILED;
    state.error = payload.error;
  },
  [actionsTypes.FETCH_CTAS_REQUEST](state) {
    state.type = actionsTypes.FETCH_CTAS_REQUEST;
    state.error = '';
  },

  [actionsTypes.ADD_CTA_SUCCESS](state, payload) {
    state.type = actionsTypes.ADD_CTA_SUCCESS;
    state.added = payload.data;
  },
  [actionsTypes.ADD_CTA_FAILED](state, payload) {
    state.type = actionsTypes.ADD_CTA_FAILED;
    state.error = payload.error;
  },
  [actionsTypes.ADD_CTA_REQUEST](state) {
    state.type = actionsTypes.ADD_CTA_REQUEST;
    state.error = '';
  },

  [actionsTypes.UPDATE_CTA_SUCCESS](state, payload) {
    state.type = actionsTypes.UPDATE_CTA_SUCCESS;
    state.updated = payload.updated;
  },
  [actionsTypes.UPDATE_CTA_FAILED](state, payload) {
    state.type = actionsTypes.UPDATE_CTA_FAILED;
    state.error = payload.error;
  },
  [actionsTypes.UPDATE_CTA_REQUEST](state) {
    state.type = actionsTypes.UPDATE_CTA_REQUEST;
    state.error = '';
  },

  [actionsTypes.DELETE_CTA_SUCCESS](state, payload) {
    state.type = actionsTypes.DELETE_CTA_SUCCESS;
    state.deleted = payload.deleted;
  },
  [actionsTypes.DELETE_CTA_FAILED](state, payload) {
    state.type = actionsTypes.DELETE_CTA_FAILED;
    state.error = payload.error;
  },
  [actionsTypes.DELETE_CTA_REQUEST](state) {
    state.type = actionsTypes.DELETE_CTA_REQUEST;
    state.error = '';
  }
};
